import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { UpdateHistory, UpdateNewMessageRecived } from '../../actions';
import { BlockedConvIcon, FalkonAiFilledIcon, LeftArrowPurpleBackgroundIcon, NewMessageRecivedIcon, ResubscribeIcon, RightArrowWhiteBackgroundIcon, SuggestedRepliesBoxCancelIcon, TransferChatDialogIcon, TransferChatSuccessIcon, TypeIndicatorIcon, UnsubscribeIcon } from '../../icon';
import { ConversationCardModel, ConversationModel, MediaModel, TypingDataModel, mapToConverstion, CombinedInterface, mapSecureChatHistoryToConversationModel, DeliveryStatus, Type } from '../../models/conversations';
import { UserModel } from '../../models/users.model';
import { ContactService } from '../../services/ContactService';
import { MessageService } from '../../services/MessageService';
import { UserService } from "../../services/UserService";
import { UtilityService } from '../../services/UtilityService';
import { ToasterTexts, ViewTextLabels, appNote, buttonLabels } from '../shared/constants';
import DisplayConversation from './display-conversation';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors";
import { ScheduledMessageModel, ScheduleMessageStatus, SecureScheduleMessageStatus } from '../../models/conversations/schedule-messages.model';
import { SecureChatService } from '../../services/SecureChatService';
import { FalkonAiService } from '../../services/FalkonAiService';
import { ReactTyped } from 'react-typed';
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import AssignStatusMessage from './assign-status-message';
import TeamNoteHistoryCard from './team-note-history-card';

interface IProps {
    CardData: ConversationCardModel;
    OpenForwardMessage: (media: MediaModel, msg: string) => void;
    UnreadCount: number;
    scrollRef: React.MutableRefObject<any>;
    activeCardIndex: number;
    pathName: string;
    DeviceHeight: number;
    IsMobileDevice: boolean;
    onEditScheduleChange?: (value: boolean, id?: any) => void;
    DuplicateSchedule?: (scheduleID: string, participantId?: string) => void;
    IsSecureChat?: boolean;
    handleSendSuggestion?: (message: string) => void;
}


const ConversationHistoryPageNew = (props: IProps) => {
    const dispatch = useDispatch();
    const ScheduleMessages: ScheduledMessageModel[] = useSelector(selector.scheduleMessages);
    const History: { [key: string]: ConversationModel[] } = useSelector(selector.history);
    const NewMessageRecived: ConversationModel[] = useSelector(selector.newMessageRecived);
    const AllUsers: UserModel[] = useSelector(selector.allUsers);
    const TypingData: TypingDataModel[] = useSelector(selector.typingData);
    const ShowingAlert: boolean = useSelector(selector.showingAlert);
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const SecureChatScheduleMessages: any[] = useSelector(selector.SecureChatScheduleMessages);


    const { GroupChat, UnReadCount, IsBlocked, PhoneNumber, Campaign } = props.CardData
    const [history, setHistory] = useState<ConversationModel[]>([])
    const inbound = history.filter(x => !x.IsOutbound).filter(x => x.Message.toLowerCase() !== "stop" && x.Message.toLowerCase() !== "unstop")
    const innerRef = useRef<any>();
    const [LoadingHistory, setLoadingHistory] = useState<boolean>(false)
    const [IsBottom, setIsBottom] = useState<boolean>(true)
    const [IsMessageRecived, setIsMessageRecived] = useState<boolean>(false)
    const [PhoneNumberTypingData, setPhoneNumberTypingData] = useState<TypingDataModel[]>(TypingData.filter(x => UtilityService.maskPhoneNumberOnLength(x.ReceiverPhoneNumber) === UtilityService.maskPhoneNumberOnLength(props.CardData.PhoneNumber)))
    const [conversationScheduleMessages, setConversationScheduleMessages] = useState([])

    const [combinedHistory, setCombinedHistory] = useState<CombinedInterface[]>([])
    const [chatType, setChatType] = useState<string>("")
    const [openSuggestedReplies, setOpenSuggestedReplies] = useState<boolean>(false)
    const [suggestedRepliesAnimation, setSuggestedRepliesAnimation] = useState<boolean>(false)
    const [suggestedReplies, setSuggestedReplies] = useState<string[]>([])
    const [suggestedRepliesId, setSuggestedRepliesId] = useState<string>("")
    const [selectedMessageForSuggestion, setSelectedMessageForSuggestion] = useState<string>("")
    const [slide, setSlide] = useState<number>(0);
    const [sortedMessage, setSortedMessages] = useState<ConversationModel[][]>([]);
    const [secureScheduleMessages, setSecureScheduleMessages] = useState<any[]>([]);

    useEffect(() => {
        setSecureScheduleMessages(SecureChatScheduleMessages.filter(y => y.PhoneNumber === props.CardData.PhoneNumber).filter(x => (x.Status === SecureScheduleMessageStatus.SCHEDULED || x.Status === SecureScheduleMessageStatus.STOPPED)).filter(x => {
            const currentTime = UtilityService.getPreferredTimeZoneTimeNow();
            const scheduleTime = new Date(x.MessageDateTime);

            return (x.ScheduleType === 1 && scheduleTime >= currentTime || x.ScheduleType !== 1)
        }))
    }, [SecureChatScheduleMessages, props.CardData])


    const historyKey = useMemo(() =>
        !!Campaign ? Campaign?.ID : !!GroupChat ? GroupChat?.ID : props.CardData?.msgType === "secure-chat" ? props.CardData.ID : PhoneNumber.replace('+', ''),
        [Campaign?.ID, GroupChat?.ID, PhoneNumber, props.CardData.ID]
    );


    const onScroll = () => {
        const { current } = innerRef;
        if (!!current) {
            let historyData = History[historyKey] || [];

            setTimeout(() => {
                if (!!current) {
                    if (!LoadingHistory && current.scrollTop < 1 && historyData.length === (props.CardData.msgType === "secure-chat" ? 30 : 100) * (Math.ceil((historyData.length === 1 ? 0 : historyData.length) / (props.CardData.msgType === "secure-chat" ? 30 : 100)))) {
                        getHistory();
                    }
                }
            }, 0);
        }

        const isBottom = Math.abs(current.scrollHeight - current.clientHeight - current.scrollTop) < 1;

        if (isBottom) {
            setIsBottom(true)
            setIsMessageRecived(false)
            UpdateNewMessageRecived(dispatch, [])
        }
        else {
            setIsBottom(false)
        }

    };

    const scrollToBottom = () => {
        const { current } = innerRef;

        if (!!current) {
            requestAnimationFrame(() => {
                current.scrollTop = current.scrollHeight
                setIsMessageRecived(false);
                UpdateNewMessageRecived(dispatch, [])
            })
        }
    }


    const getMessageDateTimeDayWise = (index: number) => {
        const filterData = sortedMessage.filter((x: any) => x.ID != "secure_chat_welcome_message")
        let newDate = UtilityService.convertToDateWithWeekFormat(
            filterData[index][0]?.MessageDateTime
        )
        if (index === 0) {
            return newDate
        }
        let prevDate = UtilityService.convertToDateWithWeekFormat(
            filterData[index - 1][0].MessageDateTime
        );
        return newDate !== prevDate ? newDate : "";
    }

    const markAsRead = () => {
        if (props.CardData?.msgType !== "secure-chat") {
            if (GroupChat?.ID) {
                MessageService.groupChatReadOrUnread(GroupChat?.ID, 0)
            }
            else {
                ContactService.setUnreadMessageCount(PhoneNumber.replace('+', ''), 0);
            }
        }
        else {
            if (props.IsSecureChat) {
                SecureChatService.MarkAllSecureChatParticipantMessagesAsRead(PhoneNumber, props.CardData.FromPhoneNumber, new Date().getTime().toString())
            }
            else {
                SecureChatService.MarkAllMessagesAsRead(PhoneNumber, props.CardData.FromPhoneNumber)
            }
        }
    }

    const updateHistory = (phoneNumber: string, history: ConversationModel[]) => {
        let temp: any = {};
        history.forEach(x => temp[x.ID] = x);
        UpdateHistory(dispatch, phoneNumber, Object.values(temp));
    }

    const holdScrollAtTop = (historyData) => {
        const { current } = innerRef;

        if (Math.ceil((historyData.length === 1 ? 0 : historyData.length) / 100) + 1 > 1) {
            requestAnimationFrame(() => {
                const heightBeforeRender = current.scrollHeight;
                setTimeout(() => {
                    current.scrollTop = current.scrollHeight - heightBeforeRender;
                }, 1500);
            })
        }
        else {
            scrollToBottom()
        }
    }

    const getHistory = () => {
        const { current } = innerRef;
        setLoadingHistory(true);
        const historyData = (History[historyKey] || []);
        if (!!props.CardData?.Campaign?.ID) {
            MessageService.getCampaignChatHistory(props.CardData.Campaign?.ID, Math.ceil((historyData.length === 1 ? 0 : historyData.length) / 100) + 1).then(res => {
                if (res.data.length) {
                    setIsMessageRecived(false)
                    updateHistory(props.CardData.Campaign?.ID, res.data.map(mapToConverstion).concat(historyData));
                    holdScrollAtTop(historyData);
                }
            }).catch(err => {
                setLoadingHistory(false);
            }).finally(() => {
                setLoadingHistory(false);
            })
        }
        else if (!!props.CardData.GroupChat?.ID) {
            MessageService.getGroupChatHistory(props.CardData.GroupChat?.ID, Math.ceil((historyData.length === 1 ? 0 : historyData.length) / 100) + 1).then(res => {
                if (res.data.length) {
                    // setIsMessageRecived(false)
                    setChatType(props.pathName)

                    updateHistory(props.CardData.GroupChat?.ID, res.data.map(mapToConverstion).concat(historyData));
                    holdScrollAtTop(historyData);

                }
            }).catch(err => {
                setLoadingHistory(false);
            }).finally(() => {
                setLoadingHistory(false);
            })
        }
        else if (props.CardData?.msgType === "secure-chat" || props.IsSecureChat) {
            if (props.IsSecureChat) {
                SecureChatService.getSecureChatHistory(props.CardData.ID, Math.ceil((historyData.length === 1 ? 0 : historyData.length) / 30) + 1).then((res) => {
                    if (!!res?.data?.length) {
                        if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                            updateHistory(props.CardData?.ID, res.data.map(x => mapSecureChatHistoryToConversationModel(x)).concat(historyData));
                            holdScrollAtTop(historyData);
                        }
                        else {
                            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                        }
                    }
                }).catch(err => {
                    setLoadingHistory(false);
                }).finally(() => {
                    setLoadingHistory(false);
                })
            }
            else {
                SecureChatService.getFalkonSecureChatHistory(props.CardData.ID, Math.ceil((historyData.length === 1 ? 0 : historyData.length) / 30) + 1).then((res) => {
                    if (!!res?.data?.length) {
                        if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                            updateHistory(props.CardData?.ID, res.data.map(x => mapSecureChatHistoryToConversationModel(x)).concat(historyData));
                            holdScrollAtTop(historyData);
                        }
                        else {
                            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                        }
                    }
                }).catch(err => {
                    setLoadingHistory(false);
                }).finally(() => {
                    setLoadingHistory(false);
                })
            }
        }
        else {
            const phoneNumber = props.CardData.PhoneNumber;
            MessageService.getHistory(phoneNumber.replace('+', ''), Math.ceil((historyData.length === 1 ? 0 : historyData.length) / 100) + 1).then(res => {
                if (res.data.length) {
                    setChatType(props.pathName)

                    updateHistory(phoneNumber.replace('+', ''), res.data.map(mapToConverstion).concat(historyData));
                    // historyData?.length > 100 ? holdScrollAtTop(historyData) : scrollToBottom()
                    holdScrollAtTop(historyData)

                }
            }).catch(err => {
                setLoadingHistory(false);
            }).finally(() => {
                setLoadingHistory(false);
            })
        }
    }

    useEffect(() => {

        if (!!(History[historyKey] || [])?.length) {
            setHistory(History[historyKey] || [])
            const conversationHistory = History[historyKey] || [];
            const safeConversationHistory = Array.isArray(conversationHistory) ? conversationHistory : [];
            setCombinedHistory(
                [
                    ...safeConversationHistory
                ])
            setLoadingHistory(false)

            const groupingMsg: Record<string, ConversationModel[]> = {};
            safeConversationHistory.forEach((msg, index) => {
                if (msg.BundleId) {
                    if (!groupingMsg[msg.BundleId]) {
                        groupingMsg[msg.BundleId] = [];
                    }
                    groupingMsg[msg.BundleId].push(msg);
                } else {
                    const key = msg.ID ?? index;
                    groupingMsg[key] = [msg];
                }
            });

            // sort inside each group so latest is first
            Object.keys(groupingMsg).forEach(key => {
                if (groupingMsg[key]?.length > 1) {
                    groupingMsg[key].sort((a, b) => new Date(b.MessageDateTime).getTime() - new Date(a.MessageDateTime).getTime());
                }
            });
            // sort groups by their old message
            const sorted = Object.values(groupingMsg).sort((a, b) => new Date(a[0].MessageDateTime).getTime() - new Date(b[0].MessageDateTime).getTime());

            setSortedMessages(sorted)
        }
        else {
            getHistory();
        }

    }, [History[historyKey] || props.CardData])

    useEffect(() => {
        handleSuggestedRepliesClose()
    }, [props.CardData.PhoneNumber])

    const handleSuggestedRepliesClose = () => {
        setSuggestedReplies([]);
        setSuggestedRepliesId("");
        setOpenSuggestedReplies(false);
        setSelectedMessageForSuggestion("")
        setSuggestedRepliesAnimation(false)
        setSlide(0)
    }

    const handlesuggestionreplyAcceptancy = () => {
        FalkonAiService.updateSuggestedRepliesAcceptancy({ suggestion_id: suggestedRepliesId, user_acceptancy: true }).then(() => {

        })
    }

    //every dom update
    useEffect(() => {
        if (chatType !== props.pathName || chatType === "") {
            setChatType(props.pathName)
            setTimeout(() => { scrollToBottom() }, 100)
        }
    }, [innerRef?.current?.scrollHeight])


    //the below useeffect is 
    // 1.to display new message icon when the scroll positon is up and recevice a message     
    // 2.and staty scroll potion there it is when send message

    useEffect(() => {
        const { current } = innerRef;

        const isNewMessage = !!NewMessageRecived.length && NewMessageRecived.filter(x => !x.IsOutbound).some(x => x.PhoneNumber === PhoneNumber || x.GroupChat?.ID === GroupChat?.ID)

        if (!!current && IsBottom) {
            setTimeout(() => { scrollToBottom() }, 100)
        }

        setTimeout(() => {
            if (!IsBottom) {
                setIsMessageRecived(isNewMessage)
            }
        }, 999);

    }, [history])


    useEffect(() => {
        setPhoneNumberTypingData(TypingData.filter(x => UtilityService.maskPhoneNumberOnLength(x.ReceiverPhoneNumber) === UtilityService.maskPhoneNumberOnLength(props.CardData.PhoneNumber)))
    }, [TypingData, props.CardData.PhoneNumber]);


    useEffect(() => {
        const campaignId = props.CardData?.CampaignId;
        const contactId = props.CardData?.Contact?.ID;
        const phone = props.CardData?.PhoneNumber.replace("+", "");
        const data: any[] = [];
        for (const sch of ScheduleMessages) {
            const campaignMatch = sch.Campaign?.ID === campaignId;
            const contactMatch = (sch.ContactIds?.includes(contactId) || sch.PhoneNumbers?.includes(phone));
            if ((campaignMatch || contactMatch) && sch.Status !== ScheduleMessageStatus.STOPPED) {
                data.push({
                    ID: sch.ID,
                    IsArchived: false,
                    IsOutbound: true,
                    FromPhoneNumber: "",
                    PhoneNumber: "",
                    MaskedPhoneNumber: "",
                    Media: sch.Media,
                    Message: sch.Message,
                    MessageDateTime: sch.NextScheduledDateTime,
                    SenderID: sch.Campaign?.CreatedById,
                    UnReadCount: 0,
                    Contact: null,
                    IsPinned: false,
                    IsBlocked: false,
                    IsUnsubscribed: false,
                    DeliveryStatus: 5,
                    IsMuted: false,
                    GroupChat: null,
                    GroupChatId: null,
                    Campaign: sch.Campaign,
                    CampaignId: sch.Campaign?.ID,
                    ConversationAuditId: "",
                    ScheduleIcon: true,
                    ScheduleType: sch.Type,
                    CronExpression: sch.CronExpression
                });
            }
        }
        setConversationScheduleMessages(data);
    }, [ScheduleMessages, props.CardData.Campaign?.ID, props.CardData?.PhoneNumber])

    const currentUserId = !props.IsSecureChat && UserService.getCurrentUserId()
    const typingUsers = AllUsers.filter(x => x.ID !== currentUserId && PhoneNumberTypingData.map(y => y.UserID).includes(x.ID))
    const typingUserNames = typingUsers.map(x => x.FirstName).join(", ").trim()

    const getUserName = useCallback((senderId: string) => {
        let data = AllUsers.find((x) => x.ID === senderId);
        if (data) {
            let name = data.FirstName + " " + data.LastName.charAt(0).toUpperCase() + data.LastName.slice(1).toLowerCase() + " started this campaign";
            return name
        }
    }, [AllUsers])

    const getAssignName = useCallback((senderId: string) => {
        return AllUsers.find(x => x.ID === senderId)?.FirstName
    }, [AllUsers])

    const IslastMessageSTOP = () => {
        const con: any = combinedHistory.filter((x: any) => x.msgType === "conversation" && !x.IsOutbound)
        return con[con?.length - 1]?.Message?.toLowerCase() !== buttonLabels.STOP.toLowerCase()
    }


    const handleReplySuggestions = (messageData) => {
        const messageIndex = history.findIndex(message => message.ID === messageData.ID);
        const startMessage = Math.max(0, messageIndex - 10)
        const HistorytoFeed = History[props.CardData.PhoneNumber.replace("+", "")]?.slice(startMessage, messageIndex)?.map(z => { return `${z.IsOutbound ? " Agent" : " Customer"} : ${!!z.Media ? `[${z.Media?.map(x => x.Url)}]` : ""} ${z.Message}` })
        setSelectedMessageForSuggestion(messageData.ID)
        setOpenSuggestedReplies(true)
        setSuggestedRepliesAnimation(true)
        setSlide(0)
        FalkonAiService.getReplySuggestions({
            organization_id: UserService.getCurrentUserOrgId(), message: messageData.Message, text: HistorytoFeed.join(""),
            image_urls: messageData.Media ? messageData.Media.map(x => x.Url) : []
        }).then((res) => {
            setSuggestedReplies(res.data.suggested_reply);
            setSuggestedRepliesId(res.data.suggested_reply_id)
            setSuggestedRepliesAnimation(false);
        }).catch((err) => {
            handleSuggestedRepliesClose();
        })
    }

    return (
        <div className='flex-1 o-hidden'>
            <div className='h-p-100 o-y-auto'
                ref={innerRef}
                onScroll={onScroll}>
                <div
                    className={`${IsTeamsApp ? ShowingAlert ? "h-v-45" : "h-v-51" : !props.IsSecureChat ? "h-v-47" : ""} w-p-100`}
                >
                    {
                        !!combinedHistory.find((x: any) => x?.ID === "secure_chat_welcome_message") &&
                        <div className='h-4 my-2 mx-auto d-flex flex-direction '>
                            <div className='mx-auto h-2 h5-semibold'>
                                🔏 Secure Messaging Enabled
                            </div>
                            <div className='mx-auto h-2 h5-medium'>
                                Your chat is encrypted for complete privacy and security
                            </div>
                        </div>
                    }
                    {
                        !!Campaign?.ID ?
                            <>
                                <div className='t-align-center mt-1 h6-regular color-nav-bar-highlight bg-color-conv-history-info-bg p-2 mx-auto w-p-75 br-2'>
                                    <div className='h6-regular'>Each recipient will get an SMS message from you privately. Only you can see this campaign name</div>
                                </div>
                                <div className="text-between-line color-con-hist-msg-date h6-regular color-primary-accent p-1">
                                    {getUserName(Campaign.CreatedById)}
                                </div>
                            </>
                            :
                            GroupChat ?
                                <div className='t-align-center mt-1  color-secondary-success h6-regular'>Shared SMS conversation where all participants can see messages and replies, fostering seamless group communication.</div>
                                :
                                <></>
                    }

                    {
                        sortedMessage.map((group, index) => {
                            const transfer = group[0];
                            return (<div>
                                {!LoadingHistory && (
                                    <div className={`color-conv-hist-date-day t-align-center mt-1`}>
                                        {getMessageDateTimeDayWise(index)}
                                    </div>)
                                }
                                {
                                    !props.IsSecureChat && group[group?.length - 1]?.ID === inbound[inbound?.length - (props.UnreadCount)]?.ID && (props.UnreadCount) > 0 &&
                                    <div className="text-between-line color-con-hist-msg-date h6-semibold color-primary-accent p-1">
                                        {(props.UnreadCount)} {(props.UnreadCount) ? ViewTextLabels.UNREAD_MESSAGE : ViewTextLabels.UNREAD_MESSAGES}
                                    </div>
                                }
                                {
                                    (!props.IsSecureChat && !!GroupChat ? GroupChat.UnReadCount : UnReadCount) > 0 ?
                                        index === sortedMessage.filter((x: any) => x.ID != "secure_chat_welcome_message").length - (!!GroupChat ? GroupChat?.UnReadCount : UnReadCount) &&
                                        <VisibilitySensor onChange={markAsRead} />
                                        : null
                                }
                                {
                                    props.IsSecureChat &&
                                        index === sortedMessage?.filter((x: any) => x.ID != "secure_chat_welcome_message").length - sortedMessage?.filter((x: any) => x.ID != "secure_chat_welcome_message").filter(x => x[0].DeliveryStatus).filter(y => y[0].DeliveryStatus === DeliveryStatus.RECEIVED).length ?
                                        <VisibilitySensor onChange={markAsRead} /> : null
                                }
                                {
                                    transfer?.BundleId ? <div className={`py-1 mx-auto d-flex ${IsMobileDevice ? "w-p-85" : "w-p-75"}`}>
                                        <div className='w-p-100 custom-header-mobile-view'>
                                            {group.filter(x => x.Type === Type.Title).map((chat) => (
                                                <div className=' w-p-96 mx-auto py-2  d-flex align-center'>
                                                    <div className='d-flex align-cente justify-center bg-color-transfer-chat p-1 br-50'><TransferChatDialogIcon className='w-3 h-3' /></div>
                                                    <div className='color-primary-accent ml-1'>
                                                        <div className='h2-semibold'>Chat Transferred</div><div className='h5-regular'>by {chat.Message?.replace("transferred a chat", "")}</div>
                                                    </div>
                                                </div>
                                            ))}
                                            {group.filter(x => x.Type === Type.Context).map((chat) => (
                                                <div className='w-p-96 mx-auto py-1 bg-color-transfer-chat-internal-note pl-2'>
                                                    <div className='color-secondary-accent h3-semibold'>Internal Note</div>
                                                    <div className='h4-regular color-primary-accent'>{chat.Message}</div>
                                                </div>
                                            ))}
                                            <div className='h3-semibold w-p-96 mx-auto color-secondary-accent mt-1'>Transferred Messages</div>
                                            {group.filter(x => x.Type === Type.Transfer)?.sort((a, b) => new Date(a.MessageDateTime).getTime() - new Date(b.MessageDateTime).getTime())?.map((chat) => (
                                                <DisplayConversation
                                                    key={chat.ID}
                                                    CardData={props.CardData}
                                                    MessageData={props.IsSecureChat ? { ...chat, IsOutbound: !chat.IsOutbound } : chat}
                                                    OpenForwardMessage={props.OpenForwardMessage}
                                                    IsSecureChat={props.IsSecureChat}
                                                    OpenSuggestedReplies={handleReplySuggestions}
                                                    selectedMessageForSuggestion={selectedMessageForSuggestion}
                                                />
                                            ))}
                                        </div>
                                    </div> :
                                        transfer.Type === Type.Alert ?
                                            <div className='w-p-95 h4-regular t-align-center text-between-line color-primary-success'><TransferChatSuccessIcon className='mr-1' />{transfer.Message}</div> :
                                            (!props.IsSecureChat && props.CardData.msgType !== "secure-chat" && transfer.Message?.toLowerCase() === buttonLabels.STOP.toLowerCase() && !transfer.IsOutbound && !GroupChat && !Campaign) ?
                                                <div className={'d-flex align-center justify-center h5-regular m-1'}> <UnsubscribeIcon className={"mr-1"} /><span>{appNote.UNSUBSCRIBE}</span> </div> :

                                                transfer.Type === Type.AssignStatus ?
                                                    <div className='d-flex align-center justify-center h5-regular w-break '>
                                                        <AssignStatusMessage Message={transfer.Message ?? ''} />
                                                    </div>
                                                    :
                                                    transfer.Type === Type.TeamNote ?
                                                        <TeamNoteHistoryCard
                                                            key={transfer.ID}
                                                            CardData={props.CardData}
                                                            MessageData={props.IsSecureChat ? { ...transfer, IsOutbound: !transfer.IsOutbound } : transfer}
                                                            IsSecureChat={props.IsSecureChat}
                                                        />
                                                        :
                                                    ((transfer.Message?.toLowerCase() === buttonLabels.UNSTOP.toLowerCase() && transfer.IsOutbound) || (transfer.Message?.toLowerCase() !== buttonLabels.UNSTOP.toLowerCase())) ?
                                                        transfer.ID !== "secure_chat_welcome_message" &&
                                                        <DisplayConversation
                                                            CardData={props.CardData}
                                                            MessageData={props.IsSecureChat ? { ...transfer, IsOutbound: !transfer.IsOutbound } : transfer}
                                                            OpenForwardMessage={props.OpenForwardMessage}
                                                            IsSecureChat={props.IsSecureChat}
                                                            OpenSuggestedReplies={handleReplySuggestions}
                                                            selectedMessageForSuggestion={selectedMessageForSuggestion}
                                                        /> :
                                                        (!props.IsSecureChat && props.CardData.msgType !== "secure-chat" && transfer.Message?.toLowerCase() === buttonLabels.UNSTOP.toLowerCase() && !GroupChat && !Campaign) ?
                                                            <div className={'d-flex align-center justify-center h5-regular m-1'}><ResubscribeIcon className={"mr-1"} /><span>{appNote.RESUBSCRIBE}</span> </div> :
                                                            <DisplayConversation
                                                                CardData={props.CardData}
                                                                MessageData={transfer}
                                                                OpenForwardMessage={props.OpenForwardMessage}
                                                            />
                                }
                            </div>)

                        })
                    }

                    {!props.IsSecureChat && props.CardData.msgType !== "secure-chat" &&
                        conversationScheduleMessages.map((chat, index) => {
                            return <div key={index}>
                                <DisplayConversation
                                    CardData={props.CardData}
                                    MessageData={chat}
                                    OpenForwardMessage={props.OpenForwardMessage}
                                    onEditScheduleChange={props.onEditScheduleChange}
                                />
                            </div>
                        })
                    }

                    {!props.IsSecureChat && props.CardData.msgType === "secure-chat" &&
                        secureScheduleMessages.map((chat, index) => {
                            return <div key={index}>
                                <DisplayConversation
                                    CardData={props.CardData}
                                    MessageData={chat}
                                    OpenForwardMessage={props.OpenForwardMessage}
                                    onEditScheduleChange={props.onEditScheduleChange}
                                    DuplicateSchedule={props.DuplicateSchedule}
                                    IsSecureChat={true}
                                />
                            </div>
                        })
                    }

                    {!props.IsSecureChat && props.CardData.msgType != "secure-chat" && IsBlocked && (
                        <div className={'d-flex align-center justify-center h5-regular m-1'}>
                            <BlockedConvIcon className={"mr-1"} /><span>{appNote.BLOCKED_CONV}</span>
                        </div>
                    )}

                    {!props.IsSecureChat && props.CardData.msgType != "secure-chat" && props.CardData?.IsUnsubscribed && IslastMessageSTOP() && (
                        <div className={'d-flex align-center justify-center h5-regular m-1'}>
                            <UnsubscribeIcon className={"mr-1"} />
                            <span>{appNote.UNSUBSCRIBE}</span>
                        </div>
                    )}

                    {LoadingHistory &&
                        <div className={`d-flex  ${(props.IsSecureChat) ? "w-p-100 t-16" : props.CardData.msgType === "secure-chat" ? "p-absolute w-fill t-10" : "p-absolute t-10 w-fill"}`}>
                            <span className="mx-auto history-loader"> </span>
                        </div>
                    }

                    {!IsBottom && IsMessageRecived &&
                        <button className='p-sticky d-flex p-1 r-1 b-2 h4-regular float-right' onClick={scrollToBottom}>
                            <NewMessageRecivedIcon />
                        </button>
                    }

                    {openSuggestedReplies &&
                        <div className={`d-flex flex-direction p-sticky b-0 bg-color-secondary px-2 ${props.IsMobileDevice ? "py-1" : "py-2"}`}>
                            {props.IsMobileDevice &&
                                <div className='w-10 h-0 ml-auto d-flex justify-flex-end p-relative b-6 l-2'>
                                    <SuggestedRepliesBoxCancelIcon className='px-1 c-pointer' onClick={() => { handleSuggestedRepliesClose() }} />
                                </div>
                            }
                            <div className='d-flex align-center min-h-3 suggested-reply-box br-5 w-p-100 py-1'>
                                {(!props.IsMobileDevice || suggestedRepliesAnimation) && <FalkonAiFilledIcon className='px-1' />}
                                {suggestedRepliesAnimation ?
                                    <div className='flex-1 d-flex flex-wrap align-center o-y-scroll py-1'>
                                        <ReactTyped
                                            strings={[
                                                "Falkon AI Generating..."
                                            ]}
                                            typeSpeed={20} // Speed of typing
                                            backSpeed={20} // Speed of backspacing
                                            loop={true} // Disable looping
                                            className={`color-ai-primary-btn ${props.IsMobileDevice ? "h5-regular" : "h5-medium"}`}
                                        />
                                    </div>
                                    :
                                    props.IsMobileDevice ?
                                        <div className={`w-p-100 ${suggestedReplies.length > 1 ? "pt-1" : "py-1"}`}>
                                            <div className={`d-flex align-center w-p-100 o-hidden`}>
                                                <div className='w-0'>
                                                    {suggestedReplies.length > 1 && slide != 0 && <LeftArrowPurpleBackgroundIcon className='p-relative r-1' style={{ top: "4px" }} onClick={() => { setSlide(slide - 1) }} />}
                                                </div>
                                                {
                                                    <div className={`flex-1 mx-2 mx-auto ai-suggested-replies h5-regular my-1 py-1 px-2 min-h-2 d-flex align-center br-3 c-pointer`} onClick={() => { props.handleSendSuggestion(suggestedReplies[slide]); handlesuggestionreplyAcceptancy(); handleSuggestedRepliesClose(); }}>
                                                        {suggestedReplies[slide]}
                                                    </div>
                                                }
                                                <div className='w-0'>
                                                    {suggestedReplies.length > 1 && slide != suggestedReplies.length - 1 && <RightArrowWhiteBackgroundIcon className='p-relative r-5' style={{ top: "2px" }} onClick={() => { setSlide(slide + 1) }} />}
                                                </div>
                                            </div>
                                            {suggestedReplies.length > 1 && <div className='w-p-100'>
                                                <div className='d-flex justify-center w-p-100 h5-medium'>
                                                    {`${slide + 1}/${suggestedReplies.length}`}
                                                </div>
                                                <div className='d-flex justify-center w-p-100'>
                                                    {suggestedReplies.map((x, index) => {
                                                        return (
                                                            <div className={`w-1 h-1 br-p-50 mx-1 my-1 ${index === slide ? "bg-color-ai-secondary-btn" : "bg-color-ai-primary-btn-box-shadow"}`}></div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        :
                                        <div className={`flex-1 d-flex flex-wrap align-center`}>
                                            {suggestedReplies.map((suggestion) => {
                                                return (
                                                    <div className={`ai-suggested-replies ${props.IsMobileDevice ? "h5-regular" : "h5-medium"} p-1 m-1 min-h-2 d-flex align-center br-3 c-pointer`} onClick={() => { props.handleSendSuggestion(suggestion); handlesuggestionreplyAcceptancy(); handleSuggestedRepliesClose(); }}>
                                                        {suggestion}
                                                    </div>
                                                )
                                            })
                                            }
                                        </div>
                                }
                                {!props.IsMobileDevice && <SuggestedRepliesBoxCancelIcon className='px-1 c-pointer' onClick={() => { handleSuggestedRepliesClose() }} />}
                            </div>
                        </div>
                    }
                    {typingUserNames &&
                        <div className="d-flex p-sticky b-0 h-3 pl-2">
                            <>
                                <TypeIndicatorIcon className={"mr-1"} /><span className="color-type-indicator-text h4-regular">{typingUserNames} {typingUsers.length > 1 ? "are" : "is"} typing…</span>
                            </>
                        </div>
                    }
                </div>
            </div>
        </div >
    )
}

export default ConversationHistoryPageNew;